import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e2536f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))

import { onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'customSwitchCheckbox',
  props: {
  checked: {
    type: Boolean,
    required: false,
  },
  className: {
    type: String,
    default: "",
  },
},
  emits: ["update:checkbox"],
  setup(__props, { emit }) {

const props = __props;




const checkedRef = ref(props.checked);

onMounted(() => {
  checkedRef.value = props.checked;
});

watch(
  () => props.checked,
  (value) => {
    checkedRef.value = value;
  },
);

watch(
  () => checkedRef.value,
  (value) => {
    emit("update:checkbox", value);
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(__props.className + ' switch')
  }, [
    _createElementVNode("input", {
      checked: checkedRef.value,
      type: "checkbox",
      onClick: _cache[0] || (_cache[0] = () => (checkedRef.value = !checkedRef.value))
    }, null, 8, _hoisted_1),
    _hoisted_2
  ], 2))
}
}

})